// Z-Index constants for consistent layering across the application
export const Z_INDEX = {
  // Base layers
  DROPDOWN: 10,
  STICKY: 20,
  
  // Overlay layers
  OVERLAY: 30,
  MODAL: 50,         // Modal dialogs
  MODAL_OVERLAY: 60, // Modal overlays (higher than modals)
  BANNER: 80,        // Error banners, notifications (highest for errors)
  
  // Top layers
  TOOLTIP: 90,
  POPOVER: 100,
  TOAST: 110,
  
  // Maximum layer
  MAXIMUM: 100
} as const;

// Tailwind CSS z-index classes mapping
export const Z_INDEX_CLASSES = {
  DROPDOWN: 'z-10',
  STICKY: 'z-20',
  OVERLAY: 'z-30',
  MODAL: 'z-50',
  MODAL_OVERLAY: 'z-60',
  BANNER: 'z-80',
  TOOLTIP: 'z-90',
  POPOVER: 'z-100',
  TOAST: 'z-110',
  MAXIMUM: 'z-100'
} as const;
